import { render, staticRenderFns } from "./FlightCheckout.vue?vue&type=template&id=b5aaeec8"
import script from "./FlightCheckout.vue?vue&type=script&lang=js"
export * from "./FlightCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports